import { Component, ContentChild, Directive, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { MenuItem } from 'primeng/api';

// eslint-disable-next-line @angular-eslint/directive-selector -- legacy selector; renaming is a breaking change (YB-1951)
@Directive({selector: '[gateMenu]',
  standalone: false,
})
export class appPopoverDirective {
  constructor(public templateRef: TemplateRef<unknown>) { }
}


type DataItem = {
  title: string,
  value: string | number
}
@Component({selector: 'app-gate-statsbox',
  templateUrl: './gate-statsbox.component.html',
  styleUrls: ['./gate-statsbox.component.scss'],
  standalone: false,
})
export class GateStatsboxComponent implements OnInit {

  @Input() id ='edit-gate-button-0'
  @Input() inverse: boolean = false;
  @ContentChild(appPopoverDirective) gateMenu!: appPopoverDirective;
  @Input() iconUrl: string = '';
  @Input() iconWidth: string | number = 26;
  @Input() openDoor: boolean = false;
  @Input() controllerIcon: boolean = false;
  @Input() title: string;
  @Input() list: DataItem[] = [];
  @Input() menu: MenuItem[];
  @Input() badge: number | string;
  @Input() asButton: boolean = false;
  @Input() status: any = false;
  @Input() boxMinWidth: string = "120px";
  @Input() class: string;
  @Output() onClick = new EventEmitter<any>();

  /** Card height class */
  @Input() heightClass: string = 'mh-120';


  ngOnInit(): void {
    if (!this.class) {
      this.class = 'card md ' + this.heightClass;
    }
    else {
      this.boxMinWidth = '';
    }
  }
  toClick(e: Event) {
    e.preventDefault();
    this.onClick.emit(true);
  }
}
